export default function NotFound() {
  return <h1>Página no encontrada (404)</h1>;
}
